const LoadingIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 16 16'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M13.917 7A6.002 6.002 0 0 0 2.083 7H1.071a7.002 7.002 0 0 1 13.858 0h-1.012z'
    ></path>
  </svg>
)

const PaletteIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='1em'
    width='1em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-palette'
  >
    <circle cx='13.5' cy='6.5' r='.5' fill='currentColor' />
    <circle cx='17.5' cy='10.5' r='.5' fill='currentColor' />
    <circle cx='8.5' cy='7.5' r='.5' fill='currentColor' />
    <circle cx='6.5' cy='12.5' r='.5' fill='currentColor' />
    <path d='M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z' />
  </svg>
)

const MenuIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5'
    />
  </svg>
)

const UserIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15.75 6a3.75 3.75 0 11-7.5 0 3.75 3.75 0 017.5 0zM4.501 20.118a7.5 7.5 0 0114.998 0A17.933 17.933 0 0112 21.75c-2.676 0-5.216-.584-7.499-1.632z'
    />
  </svg>
)
const PlusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path strokeLinecap='round' strokeLinejoin='round' d='M12 4.5v15m7.5-7.5h-15' />
  </svg>
)

const FilmIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3.375 19.5h17.25m-17.25 0a1.125 1.125 0 01-1.125-1.125M3.375 19.5h1.5C5.496 19.5 6 18.996 6 18.375m-3.75 0V5.625m0 12.75v-1.5c0-.621.504-1.125 1.125-1.125m18.375 2.625V5.625m0 12.75c0 .621-.504 1.125-1.125 1.125m1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125m0 3.75h-1.5A1.125 1.125 0 0118 18.375M20.625 4.5H3.375m17.25 0c.621 0 1.125.504 1.125 1.125M20.625 4.5h-1.5C18.504 4.5 18 5.004 18 5.625m3.75 0v1.5c0 .621-.504 1.125-1.125 1.125M3.375 4.5c-.621 0-1.125.504-1.125 1.125M3.375 4.5h1.5C5.496 4.5 6 5.004 6 5.625m-3.75 0v1.5c0 .621.504 1.125 1.125 1.125m0 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125m1.5-3.75C5.496 8.25 6 7.746 6 7.125v-1.5M4.875 8.25C5.496 8.25 6 8.754 6 9.375v1.5m0-5.25v5.25m0-5.25C6 5.004 6.504 4.5 7.125 4.5h9.75c.621 0 1.125.504 1.125 1.125m1.125 2.625h1.5m-1.5 0A1.125 1.125 0 0118 7.125v-1.5m1.125 2.625c-.621 0-1.125.504-1.125 1.125v1.5m2.625-2.625c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125M18 5.625v5.25M7.125 12h9.75m-9.75 0A1.125 1.125 0 016 10.875M7.125 12C6.504 12 6 12.504 6 13.125m0-2.25C6 11.496 5.496 12 4.875 12M18 10.875c0 .621-.504 1.125-1.125 1.125M18 10.875c0 .621.504 1.125 1.125 1.125m-2.25 0c.621 0 1.125.504 1.125 1.125m-12 5.25v-5.25m0 5.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125m-12 0v-1.5c0-.621-.504-1.125-1.125-1.125M18 18.375v-5.25m0 5.25v-1.5c0-.621.504-1.125 1.125-1.125M18 13.125v1.5c0 .621.504 1.125 1.125 1.125M18 13.125c0-.621.504-1.125 1.125-1.125M6 13.125v1.5c0 .621-.504 1.125-1.125 1.125M6 13.125C6 12.504 5.496 12 4.875 12m-1.5 0h1.5m-1.5 0c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125M19.125 12h1.5m0 0c.621 0 1.125.504 1.125 1.125v1.5c0 .621-.504 1.125-1.125 1.125m-17.25 0h1.5m14.25 0h1.5'
    />
  </svg>
)

const DiscIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    height='1em'
    width='1em'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    className='lucide lucide-disc-3'
  >
    <circle cx='12' cy='12' r='10' />
    <path d='M6 12c0-1.7.7-3.2 1.8-4.2' />
    <circle cx='12' cy='12' r='2' />
    <path d='M18 12c0 1.7-.7 3.2-1.8 4.2' />
  </svg>
)

const SquareActivity = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <rect width='18' height='18' x='3' y='3' rx='2' />
    <path d='M17 12h-2l-2 5-2-10-2 5H7' />
  </svg>
)

const QCIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M12 3c2.755 0 5.455.232 8.083.678.533.09.917.556.917 1.096v1.044a2.25 2.25 0 01-.659 1.591l-5.432 5.432a2.25 2.25 0 00-.659 1.591v2.927a2.25 2.25 0 01-1.244 2.013L9.75 21v-6.568a2.25 2.25 0 00-.659-1.591L3.659 7.409A2.25 2.25 0 013 5.818V4.774c0-.54.384-1.006.917-1.096A48.32 48.32 0 0112 3z'
    />
  </svg>
)
const PendingIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z'></path>
  </svg>
)

const HomeIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25'
    />
  </svg>
)

const AuthIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z'
    />
  </svg>
)

const KeyIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15.75 5.25a3 3 0 013 3m3 0a6 6 0 01-7.029 5.912c-.563-.097-1.159.026-1.563.43L10.5 17.25H8.25v2.25H6v2.25H2.25v-2.818c0-.597.237-1.17.659-1.591l6.499-6.499c.404-.404.527-1 .43-1.563A6 6 0 1121.75 8.25z'
    />
  </svg>
)

const LogoutIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15M12 9l-3 3m0 0l3 3m-3-3h12.75'
    />
  </svg>
)
const MetadataIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    width='1em'
    height='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5'
    />
  </svg>
)

const DocPlusIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m3.75 9v6m3-3H9m1.5-12H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z'
    />
  </svg>
)

const StackIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    width='1em'
    height='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M6.429 9.75L2.25 12l4.179 2.25m0-4.5l5.571 3 5.571-3m-11.142 0L2.25 7.5 12 2.25l9.75 5.25-4.179 2.25m0 0L21.75 12l-4.179 2.25m0 0l4.179 2.25L12 21.75 2.25 16.5l4.179-2.25m11.142 0l-5.571 3-5.571-3'
    />
  </svg>
)
const BackSpaceIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M12 9.75L14.25 12m0 0l2.25 2.25M14.25 12l2.25-2.25M14.25 12L12 14.25m-2.58 4.92l-6.375-6.375a1.125 1.125 0 010-1.59L9.42 4.83c.211-.211.498-.33.796-.33H19.5a2.25 2.25 0 012.25 2.25v10.5a2.25 2.25 0 01-2.25 2.25h-9.284c-.298 0-.585-.119-.796-.33z'
    />
  </svg>
)

const PerformanceIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M3 13.125C3 12.504 3.504 12 4.125 12h2.25c.621 0 1.125.504 1.125 1.125v6.75C7.5 20.496 6.996 21 6.375 21h-2.25A1.125 1.125 0 013 19.875v-6.75zM9.75 8.625c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125v11.25c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V8.625zM16.5 4.125c0-.621.504-1.125 1.125-1.125h2.25C20.496 3 21 3.504 21 4.125v15.75c0 .621-.504 1.125-1.125 1.125h-2.25a1.125 1.125 0 01-1.125-1.125V4.125z'
    />
  </svg>
)

const EarningsIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    width='1em'
    height='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M2.25 18.75a60.07 60.07 0 0115.797 2.101c.727.198 1.453-.342 1.453-1.096V18.75M3.75 4.5v.75A.75.75 0 013 6h-.75m0 0v-.375c0-.621.504-1.125 1.125-1.125H20.25M2.25 6v9m18-10.5v.75c0 .414.336.75.75.75h.75m-1.5-1.5h.375c.621 0 1.125.504 1.125 1.125v9.75c0 .621-.504 1.125-1.125 1.125h-.375m1.5-1.5H21a.75.75 0 00-.75.75v.75m0 0H3.75m0 0h-.375a1.125 1.125 0 01-1.125-1.125V15m1.5 1.5v-.75A.75.75 0 003 15h-.75M15 10.5a3 3 0 11-6 0 3 3 0 016 0zm3 0h.008v.008H18V10.5zm-12 0h.008v.008H6V10.5z'
    />
  </svg>
)

const EditIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L10.582 16.07a4.5 4.5 0 01-1.897 1.13L6 18l.8-2.685a4.5 4.5 0 011.13-1.897l8.932-8.931zm0 0L19.5 7.125M18 14v4.75A2.25 2.25 0 0115.75 21H5.25A2.25 2.25 0 013 18.75V8.25A2.25 2.25 0 015.25 6H10'
    />
  </svg>
)

const BellIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    width='1em'
    height='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M14.857 17.082a23.848 23.848 0 005.454-1.31A8.967 8.967 0 0118 9.75v-.7V9A6 6 0 006 9v.75a8.967 8.967 0 01-2.312 6.022c1.733.64 3.56 1.085 5.455 1.31m5.714 0a24.255 24.255 0 01-5.714 0m5.714 0a3 3 0 11-5.714 0'
    />
  </svg>
)

const ChevronDownIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M19.5 8.25l-7.5 7.5-7.5-7.5'
    />
  </svg>
)

const ChevronUpIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M4.5 15.75l7.5-7.5 7.5 7.5'
    />
  </svg>
)
const CloseIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path strokeLinecap='round' strokeLinejoin='round' d='M6 18L18 6M6 6l12 12' />
  </svg>
)

const EyeClosedIcon = () => (
  <svg
    stroke='currentColor'
    fill='none'
    strokeWidth='0'
    viewBox='0 0 15 15'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.7649 6.07596C14.9991 6.22231 15.0703 6.53079 14.9239 6.76495C14.4849 7.46743 13.9632 8.10645 13.3702 8.66305L14.5712 9.86406C14.7664 10.0593 14.7664 10.3759 14.5712 10.5712C14.3759 10.7664 14.0593 10.7664 13.8641 10.5712L12.6011 9.30817C11.805 9.90283 10.9089 10.3621 9.93375 10.651L10.383 12.3277C10.4544 12.5944 10.2961 12.8685 10.0294 12.94C9.76267 13.0115 9.4885 12.8532 9.41704 12.5865L8.95917 10.8775C8.48743 10.958 8.00036 10.9999 7.50001 10.9999C6.99965 10.9999 6.51257 10.958 6.04082 10.8775L5.58299 12.5864C5.51153 12.8532 5.23737 13.0115 4.97064 12.94C4.7039 12.8686 4.5456 12.5944 4.61706 12.3277L5.06625 10.651C4.09111 10.3621 3.19503 9.90282 2.3989 9.30815L1.1359 10.5712C0.940638 10.7664 0.624058 10.7664 0.428798 10.5712C0.233537 10.3759 0.233537 10.0593 0.428798 9.86405L1.62982 8.66303C1.03682 8.10643 0.515113 7.46742 0.0760677 6.76495C-0.0702867 6.53079 0.000898544 6.22231 0.235065 6.07596C0.469231 5.9296 0.777703 6.00079 0.924058 6.23496C1.40354 7.00213 1.989 7.68057 2.66233 8.2427C2.67315 8.25096 2.6837 8.25972 2.69397 8.26898C4.00897 9.35527 5.65537 9.99991 7.50001 9.99991C10.3078 9.99991 12.6564 8.5063 14.076 6.23495C14.2223 6.00079 14.5308 5.9296 14.7649 6.07596Z'
      fill='currentColor'
    ></path>
  </svg>
)

const EyeOpenIcon = () => (
  <svg
    stroke='currentColor'
    fill='none'
    strokeWidth='0'
    viewBox='0 0 15 15'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.5 11C4.80285 11 2.52952 9.62184 1.09622 7.50001C2.52952 5.37816 4.80285 4 7.5 4C10.1971 4 12.4705 5.37816 13.9038 7.50001C12.4705 9.62183 10.1971 11 7.5 11ZM7.5 3C4.30786 3 1.65639 4.70638 0.0760002 7.23501C-0.0253338 7.39715 -0.0253334 7.60288 0.0760014 7.76501C1.65639 10.2936 4.30786 12 7.5 12C10.6921 12 13.3436 10.2936 14.924 7.76501C15.0253 7.60288 15.0253 7.39715 14.924 7.23501C13.3436 4.70638 10.6921 3 7.5 3ZM7.5 9.5C8.60457 9.5 9.5 8.60457 9.5 7.5C9.5 6.39543 8.60457 5.5 7.5 5.5C6.39543 5.5 5.5 6.39543 5.5 7.5C5.5 8.60457 6.39543 9.5 7.5 9.5Z'
      fill='currentColor'
    ></path>
  </svg>
)

const CheckIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 16 16'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-3.97-3.03a.75.75 0 0 0-1.08.022L7.477 9.417 5.384 7.323a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-.01-1.05z'></path>
  </svg>
)

const InfoIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 16 16'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16zm.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2z'></path>
  </svg>
)

const DeleteIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z'></path>
  </svg>
)

const TimerIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M256 48C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48zm14 226c0 7.7-6.3 14-14 14h-96c-7.7 0-14-6.3-14-14s6.3-14 14-14h82V128c0-7.7 6.3-14 14-14s14 6.3 14 14v146z'></path>
  </svg>
)

const DashIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    version='1.0'
    width='1em'
    height='1em'
    viewBox='0 0 1080.000000 1080.000000'
    preserveAspectRatio='xMidYMid meet'
  >
    <path
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d=' M952.171997,544.976135   C951.998901,548.590820 951.825745,552.205505 951.733887,556.254883   C950.911194,566.612915 950.106689,576.546387 949.084412,586.457458   C946.245667,613.979797 940.607422,640.921570 932.080688,667.626099   C931.694763,669.073792 931.295349,670.142883 930.685181,671.818726   C929.940674,674.258057 929.406860,676.090576 928.873047,677.923096   C928.873047,677.923096 928.953369,677.943726 928.691040,678.096252   C928.300842,678.830811 928.173035,679.412842 928.045288,679.994873   C926.099304,685.404846 924.516541,690.981628 922.126099,696.187500   C918.069031,705.022766 913.580322,713.663940 909.135864,722.316223   C895.777588,748.321167 879.112427,772.021057 859.148804,793.808655   C841.953430,811.604187 823.717712,827.705322 803.243042,841.139160   C797.983521,844.589905 792.609314,847.865906 787.116699,851.511841   C771.728638,859.148315 756.782227,867.136169 741.234985,873.700867   C713.730347,885.314453 684.915894,892.628052 655.139587,897.671143   C642.050476,899.589233 629.328125,901.730652 616.516296,902.830200   C605.527649,903.773315 594.437012,903.534546 583.390930,903.796326   C580.235046,903.871155 577.077332,903.869080 573.459045,903.991333   C547.267029,904.010742 521.536438,903.930664 495.805878,903.876465   C485.843842,903.855469 475.881714,903.893005 465.458435,903.994385   C450.212708,904.015137 435.428223,903.897156 420.643646,903.885376   C389.734985,903.860657 358.826233,903.891907 327.025574,903.908081   C324.090698,903.971863 322.047791,904.027771 320.004913,904.083618   C318.283539,904.022583 316.562195,903.961548 314.418671,903.991943   C307.941589,903.713806 301.811981,903.815979 295.847839,902.872437   C284.710602,901.110535 277.015717,894.206787 270.510315,884.243469   C285.123138,876.259094 299.415161,868.449951 314.176086,860.325012   C315.066956,859.678345 315.488892,859.347473 315.910828,859.016663   C316.105804,859.002686 316.300751,858.988647 316.990051,858.849976   C317.797882,858.565002 317.959961,858.308838 317.970642,857.956909   C318.809601,857.612427 319.648529,857.267883 321.014587,856.662109   C322.069672,855.969482 322.597687,855.538025 323.125671,855.106628   C324.562622,854.424622 325.999573,853.742554 328.015320,852.848999   C329.334351,852.088806 330.074615,851.540222 330.814880,850.991638   C331.168579,850.865601 331.522247,850.739502 332.287903,850.328857   C333.220642,849.802490 333.741333,849.560669 334.262054,849.318848   C334.262054,849.318848 334.280457,849.215698 334.631287,849.165894   C376.203583,826.674377 417.474304,804.322144 458.596619,781.700256   C465.225311,778.053772 471.818329,776.452881 479.385712,776.524902   C510.029999,776.816345 540.678711,776.657593 571.325745,776.612671   C574.968018,776.607361 578.609802,776.280945 582.693115,776.206055   C599.121826,774.605042 615.109131,772.901245 631.513062,771.213135   C670.513245,763.836914 705.293457,748.836792 734.948914,722.252625   C746.041931,712.308411 756.054626,701.678528 764.633057,689.705688   C787.285400,658.090210 800.043091,622.432007 804.773621,584.121033   C807.156311,564.824097 808.153015,545.173950 807.577087,525.748718   C807.073486,508.764801 803.490662,491.872162 801.255127,474.523926   C801.159729,473.449738 801.139038,472.776184 800.986328,472.134033   C790.021240,426.013702 769.337830,385.611572 731.903076,354.753906   C731.172791,354.112671 730.569397,353.715302 729.922241,353.180786   C729.878479,353.043701 729.590698,353.046051 729.414429,352.788879   C715.146240,340.986115 699.694885,331.561493 682.744202,325.032471   C670.446045,320.295502 657.602234,316.975250 644.687378,312.836121   C642.942810,312.420624 641.512634,312.192291 639.833008,311.753540   C638.736206,311.418671 637.888855,311.294159 636.729797,311.043091   C635.972290,310.933258 635.526611,310.949982 634.828613,310.763306   C633.736023,310.435211 632.895630,310.310455 631.733643,310.057068   C630.494263,309.894867 629.576599,309.861267 628.394409,309.593445   C627.437805,309.299133 626.745667,309.238983 625.711914,309.054199   C624.403931,308.908691 623.437683,308.887787 622.179932,308.652374   C620.946594,308.363098 620.004700,308.288330 618.685120,308.112122   C617.269958,307.980408 616.232483,307.950165 614.871216,307.727600   C613.052551,307.425385 611.557678,307.315521 609.605225,307.099030   C605.132324,306.982605 601.116943,306.972809 596.968079,306.675140   C596.233032,306.316101 595.631531,306.244934 594.586182,306.077881   C591.429138,305.978027 588.715881,305.974060 585.592896,305.844238   C583.195374,305.664276 581.207703,305.610168 578.888428,305.367554   C577.309387,305.281677 576.061829,305.384338 574.357788,305.482788   C569.406738,305.476776 564.912048,305.449036 560.417664,305.477875   C544.284851,305.581329 528.152100,305.703949 511.566528,305.687286   C498.804169,305.506317 486.494598,305.457336 473.884949,305.244446   C473.357330,305.093384 473.129761,305.106201 472.570557,305.010803   C462.214661,299.576904 452.190369,294.251282 442.055603,288.687378   C441.631500,288.325134 441.317871,288.201172 440.993408,288.038940   C440.982605,288.000732 440.906281,288.022888 440.760406,287.782013   C440.087585,287.429077 439.560638,287.316986 438.734497,287.110168   C438.018524,286.982544 437.601685,286.949615 437.107300,286.571899   C435.146790,284.952118 433.343353,283.535645 431.367310,282.426666   C422.552734,277.479828 413.751373,272.503357 404.828644,267.756714   C390.295258,260.025299 375.670929,252.464737 361.084991,244.832062   C342.431335,234.100433 323.821075,223.292282 305.102295,212.675507   C297.797577,208.532471 290.248718,204.819931 282.435974,200.874878   C279.088287,198.710266 276.115753,196.582062 272.911896,194.288269   C280.621368,183.384476 291.275116,178.617523 304.577026,178.004883   C306.652832,178.005264 308.308624,178.167023 309.964447,178.167160   C362.003479,178.171478 414.042511,178.160080 466.542480,178.057343   C476.326538,178.043961 485.649628,178.132217 494.972809,178.203308   C535.121399,178.509476 575.270386,178.772095 615.418213,179.158661   C620.902466,179.211456 626.380981,179.873291 632.306519,180.203064   C645.719116,182.057999 658.738586,183.668839 671.645996,185.921814   C714.732544,193.442429 755.394958,207.769638 793.541870,229.993988   C807.507507,239.833710 821.535889,249.099838 834.663147,259.503174   C854.208496,274.992859 870.665710,293.582703 885.786621,313.795471   C896.279053,331.478088 906.515320,348.941681 916.946655,366.702301   C920.133728,374.218506 923.125916,381.437653 926.369934,388.899414   C931.387756,404.851257 936.153687,420.560486 941.060425,436.641663   C946.147278,459.804810 949.854492,482.772888 951.128052,506.548828   C951.291809,509.445404 951.389832,511.890839 951.639526,515.064453   C951.887634,516.861755 951.984009,517.930786 952.080444,518.999878   C952.049133,520.725403 952.017822,522.450989 952.006714,525.062012   C952.075195,532.290405 952.123596,538.633301 952.171997,544.976135  z'
    />
    <path
      xmlns='http://www.w3.org/2000/svg'
      fill='currentColor'
      opacity='1.000000'
      stroke='none'
      d=' M375.867065,772.476074   C361.709778,779.986755 347.477112,787.359558 333.415558,795.045349   C318.044006,803.447205 302.609467,811.181335 284.222870,809.245178   C271.151550,807.868713 259.436707,803.399841 249.105530,795.280273   C247.677399,794.157898 246.184814,793.117554 244.382614,791.961792   C235.328339,782.425842 228.336792,771.907593 225.767807,759.128845   C224.572006,753.180664 224.114868,746.990906 224.110443,740.910034   C224.017380,612.923157 224.036987,484.936249 223.953918,356.490753   C224.454071,350.676483 224.258255,345.093597 225.747223,340.003601   C233.001968,315.203613 249.910172,300.084351 274.558319,293.566742   C290.277069,289.410339 305.478210,291.728577 319.939667,299.024384   C323.045990,300.591553 326.069611,302.322662 329.694031,304.312927   C338.686829,309.226288 347.100616,313.835205 355.550446,318.377106   C372.028381,327.234283 388.526489,336.053955 405.032013,344.933716   C405.047760,344.978333 405.136902,344.946381 405.299255,345.173279   C405.976654,345.578522 406.491699,345.756836 407.207214,346.217194   C414.828339,350.559753 422.222931,354.668793 429.675018,358.670715   C445.436096,367.134644 461.227203,375.542664 477.193817,384.263611   C493.885529,393.497437 510.389435,402.441254 527.116821,411.635620   C530.780334,413.631500 534.220276,415.376831 537.845459,417.410828   C538.658752,417.975586 539.286865,418.251770 540.168457,418.735596   C550.568848,424.320557 560.715698,429.697845 571.089111,435.338470   C582.508667,441.699371 593.678284,447.840546 604.900269,453.884521   C622.966858,463.614990 641.068054,473.281342 659.338257,483.257019   C666.233093,487.200165 672.980530,490.796234 679.648743,494.533691   C702.235413,507.193542 714.838257,526.385864 714.795166,552.368774   C714.752808,577.898193 702.652100,597.272034 680.304382,609.558044   C653.659180,624.206726 626.646790,638.186157 599.838013,652.538635   C585.499329,660.214966 571.254395,668.066223 556.607849,675.892883   C549.749878,679.523438 543.285278,683.163025 536.745728,686.662720   C521.891785,694.612061 507.005890,702.501709 492.124084,710.398865   C472.220428,720.960815 452.284149,731.461609 432.407013,742.073120   C413.530151,752.150818 394.711365,762.337341 375.867065,772.476074  M248.870621,634.491943   C248.870621,638.598083 248.870621,642.704163 248.870621,646.866211   C267.549377,646.866211 285.622650,646.866211 303.728058,646.866211   C303.728058,628.742859 303.728058,610.884766 303.728058,593.215576   C285.256866,593.215576 267.181122,593.215576 248.870544,593.215576   C248.870544,606.872314 248.870544,620.182861 248.870621,634.491943  M251.629929,355.869751   C248.292816,355.438324 248.874268,357.821411 248.873566,359.743378   C248.867813,375.574524 248.866058,391.405701 248.897064,407.236786   C248.898880,408.162750 249.194656,409.088135 249.313675,409.781250   C267.721619,409.781250 285.801239,409.781250 303.819519,409.781250   C303.819519,391.686859 303.819519,373.941681 303.819519,355.867645   C286.550110,355.867645 269.581085,355.867645 251.629929,355.869751  M304.122437,548.499695   C304.122437,537.067383 304.122437,525.635071 304.122437,514.124268   C285.446350,514.124268 267.371063,514.124268 249.256378,514.124268   C249.256378,532.242554 249.256378,550.103210 249.256378,567.781494   C267.721161,567.781494 285.797272,567.781494 304.122375,567.781494   C304.122375,561.458313 304.122375,555.478943 304.122437,548.499695  M248.871216,443.533386   C248.871216,458.629913 248.871216,473.726440 248.871216,488.855621   C267.571960,488.855621 285.649170,488.855621 303.897888,488.855621   C303.897888,470.839233 303.897888,453.095825 303.897888,435.229980   C285.471710,435.229980 267.275879,435.229980 248.870804,435.229980   C248.870804,437.907501 248.870804,440.226807 248.871216,443.533386  M304.120148,723.377563   C304.120148,706.626282 304.120148,689.875000 304.120148,673.172363   C285.359772,673.172363 267.285339,673.172363 249.128906,673.172363   C249.128906,691.215027 249.128906,708.955933 249.128906,727.111206   C266.833862,727.111206 284.285309,727.147705 301.735016,726.994263   C302.536987,726.987122 303.323975,725.273438 304.120148,723.377563  z'
    />
    <g
      transform='translate(0.000000,1080.000000) scale(0.100000,-0.100000)'
      fill='currentColor'
      stroke='none'
    >
      {/* <path d='M0 5400 l0 -5400 5400 0 5400 0 0 5400 0 5400 -5400 0 -5400 0 0 -5400z m6120 3620 c626 -37 1129 -164 1612 -406 918 -460 1533 -1322 1717 -2409 54 -314 75 -747 52 -1060 -71 -970 -408 -1762 -1001 -2355 -489 -490 -1121 -805 -1890 -944 -408 -73 -538 -78 -2225 -74 l-1450 3 -62 29 c-66 30 -178 135 -171 159 3 6 38 30 79 53 41 22 238 129 439 238 201 110 388 211 415 226 28 15 185 100 350 190 165 90 386 211 490 269 l190 106 700 6 c646 5 710 7 831 27 672 108 1165 411 1498 924 453 697 502 1849 111 2628 -159 316 -374 561 -659 751 -264 176 -552 282 -936 345 -89 15 -209 18 -800 23 -694 6 -695 6 -732 28 -20 12 -153 86 -295 164 -142 78 -274 151 -293 162 -19 11 -118 66 -220 122 -102 56 -329 182 -505 280 -176 97 -393 217 -482 267 -90 49 -163 93 -163 97 0 13 95 99 130 117 84 43 67 42 1620 43 865 1 1554 -3 1650 -9z m-3064 -1150 c84 -22 85 -22 794 -408 371 -201 481 -261 913 -496 194 -106 460 -250 1392 -756 358 -194 675 -370 706 -391 126 -85 232 -244 264 -395 38 -180 -5 -379 -113 -524 -73 -97 -148 -149 -430 -301 -147 -78 -460 -246 -697 -372 -236 -126 -763 -407 -1170 -625 -407 -217 -909 -485 -1115 -595 -206 -109 -384 -205 -395 -212 -40 -25 -162 -63 -239 -75 -119 -18 -244 4 -375 67 -105 50 -233 178 -283 283 -80 164 -73 -41 -73 2240 0 1941 1 2038 18 2100 98 348 450 550 803 460z' />
      <path d='M2480 6980 l0 -270 275 0 275 0 0 270 0 270 -275 0 -275 0 0 -270z' />
      <path d='M2480 6190 l0 -270 275 0 275 0 0 270 0 270 -275 0 -275 0 0 -270z' />
      <path d='M2480 5400 l0 -270 275 0 275 0 0 270 0 270 -275 0 -275 0 0 -270z' />
      <path d='M2480 4610 l0 -270 275 0 275 0 0 270 0 270 -275 0 -275 0 0 -270z' />
      <path d='M2480 3810 l0 -270 275 0 275 0 0 270 0 270 -275 0 -275 0 0 -270z' /> */}
    </g>
  </svg>
)

const BarIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z'></path>
  </svg>
)
const AnalyticsIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    className='w-6 h-6'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M7.5 14.25v2.25m3-4.5v4.5m3-6.75v6.75m3-9v9M6 20.25h12A2.25 2.25 0 0020.25 18V6A2.25 2.25 0 0018 3.75H6A2.25 2.25 0 003.75 6v12A2.25 2.25 0 006 20.25z'
    />
  </svg>
)

const YoutubeIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 1024 1024'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'></path>
  </svg>
)
const UploadBulk = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    fill='none'
    viewBox='0 0 24 24'
    strokeWidth={1.5}
    stroke='currentColor'
    height='1em'
    width='1em'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M7.5 7.5h-.75A2.25 2.25 0 004.5 9.75v7.5a2.25 2.25 0 002.25 2.25h7.5a2.25 2.25 0 002.25-2.25v-7.5a2.25 2.25 0 00-2.25-2.25h-.75m0-3l-3-3m0 0l-3 3m3-3v11.25m6-2.25h.75a2.25 2.25 0 012.25 2.25v7.5a2.25 2.25 0 01-2.25 2.25h-7.5a2.25 2.25 0 01-2.25-2.25v-.75'
    />
  </svg>
)

const GoogleIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    version='1.1'
    x='0px'
    y='0px'
    viewBox='0 0 48 48'
    enableBackground='new 0 0 48 48'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='#FFC107'
      d='M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12
c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24
c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z'
    ></path>
    <path
      fill='#FF3D00'
      d='M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657
C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z'
    ></path>
    <path
      fill='#4CAF50'
      d='M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36
c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z'
    ></path>
    <path
      fill='#1976D2'
      d='M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571
c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z'
    ></path>
  </svg>
)

const UploadIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='32'
      d='M320 367.79h76c55 0 100-29.21 100-83.6s-53-81.47-96-83.6c-8.89-85.06-71-136.8-144-136.8-69 0-113.44 45.79-128 91.2-60 5.7-112 43.88-112 106.4s54 106.4 120 106.4h56'
    ></path>
    <path
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='32'
      d='M320 255.79l-64-64-64 64m64 192.42V207.79'
    ></path>
  </svg>
)

const FileIcon = () => (
  <svg
    stroke='currentColor'
    fill='none'
    strokeWidth='2'
    viewBox='0 0 24 24'
    strokeLinecap='round'
    strokeLinejoin='round'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'></path>
    <polyline points='14 2 14 8 20 8'></polyline>
    <line x1='16' y1='13' x2='8' y2='13'></line>
    <line x1='16' y1='17' x2='8' y2='17'></line>
    <polyline points='10 9 9 9 8 9'></polyline>
  </svg>
)

const CaretUpIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 1024 1024'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'></path>
  </svg>
)

const CaretDownIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 1024 1024'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'></path>
  </svg>
)

const PercentIcon = () => (
  <svg
    stroke='currentColor'
    fill='none'
    strokeWidth='1.5'
    viewBox='0 0 24 24'
    aria-hidden='true'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      strokeLinecap='round'
      strokeLinejoin='round'
      d='M9 14.25l6-6m4.5-3.493V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185zM9.75 9h.008v.008H9.75V9zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm4.125 4.5h.008v.008h-.008V13.5zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z'
    ></path>
  </svg>
)

const SavingsIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='none' d='M0 0h24v24H0z'></path>
    <path d='M15 10c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zM8 9h5V7H8v2zm14-1.5v6.97l-2.82.94L17.5 21H12v-2h-2v2H4.5S2 12.54 2 9.5 4.46 4 7.5 4h5c.91-1.21 2.36-2 4-2a1.498 1.498 0 011.38 2.08c-.14.34-.26.73-.32 1.15l2.27 2.27H22zm-2 2h-1L15.5 6c0-.65.09-1.29.26-1.91-.97.25-1.76.97-2.09 1.91H7.5C5.57 6 4 7.57 4 9.5c0 1.88 1.22 6.65 2.01 9.5H8v-2h6v2h2.01l1.55-5.15 2.44-.82V9.5z'></path>
  </svg>
)

const MoneyBagIcon = () => (
  <svg
    stroke='currentColor'
    fill='none'
    strokeWidth='2'
    viewBox='0 0 24 24'
    strokeLinecap='round'
    strokeLinejoin='round'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
    <path d='M9.5 3h5a1.5 1.5 0 0 1 1.5 1.5a3.5 3.5 0 0 1 -3.5 3.5h-1a3.5 3.5 0 0 1 -3.5 -3.5a1.5 1.5 0 0 1 1.5 -1.5z'></path>
    <path d='M4 17v-1a8 8 0 1 1 16 0v1a4 4 0 0 1 -4 4h-8a4 4 0 0 1 -4 -4z'></path>
  </svg>
)
const WarningIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 512 512'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='32'
      d='M85.57 446.25h340.86a32 32 0 0028.17-47.17L284.18 82.58c-12.09-22.44-44.27-22.44-56.36 0L57.4 399.08a32 32 0 0028.17 47.17z'
    ></path>
    <path
      fill='none'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='32'
      d='M250.26 195.39l5.74 122 5.73-121.95a5.74 5.74 0 00-5.79-6h0a5.74 5.74 0 00-5.68 5.95z'
    ></path>
    <path d='M256 397.25a20 20 0 1120-20 20 20 0 01-20 20z'></path>
  </svg>
)

const WarningIconAlt = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g>
      <path fill='none' d='M0 0h24v24H0z'></path>
      <path d='M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm-1-7v2h2v-2h-2zm0-8v6h2V7h-2z'></path>
    </g>
  </svg>
)
const CalendarIcon = () => (
  <svg
    stroke='currentColor'
    fill='currentColor'
    strokeWidth='0'
    viewBox='0 0 24 24'
    height='1em'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path fill='none' d='M0 0h24v24H0V0z'></path>
    <path d='M20 3h-1V1h-2v2H7V1H5v2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 18H4V10h16v11zm0-13H4V5h16v3z'></path>
  </svg>
)

export {
  LoadingIcon,
  DiscIcon,
  MenuIcon,
  UserIcon,
  PaletteIcon,
  PlusIcon,
  FilmIcon,
  QCIcon,
  PendingIcon,
  HomeIcon,
  AuthIcon,
  KeyIcon,
  LogoutIcon,
  MetadataIcon,
  DocPlusIcon,
  StackIcon,
  BackSpaceIcon,
  PerformanceIcon,
  EarningsIcon,
  EditIcon,
  BellIcon,
  ChevronDownIcon,
  ChevronUpIcon,
  CloseIcon,
  EyeClosedIcon,
  EyeOpenIcon,
  CheckIcon,
  InfoIcon,
  DeleteIcon,
  TimerIcon,
  DashIcon,
  BarIcon,
  AnalyticsIcon,
  YoutubeIcon,
  UploadBulk,
  GoogleIcon,
  UploadIcon,
  FileIcon,
  CaretDownIcon,
  SquareActivity,
  CaretUpIcon,
  PercentIcon,
  SavingsIcon,
  MoneyBagIcon,
  WarningIcon,
  WarningIconAlt,
  CalendarIcon,
}
